let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9CZtu")).then(() => parcelRequire('5AYIB'));